/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */

import { useEffect } from 'react';
import UploadableImage from '../../Components/UploadableImage';

const ImageSection = ({ images, setImages, data, isSuccess }) => {
  useEffect(() => {
    if (!data || !isSuccess) return;

    // Check if preview is already set to avoid looping
    const alreadyInitialized = images.some((img) => img.previewUrl);
    if (alreadyInitialized) return;

    const objectUrls = [];

    const updatedImages = images.map((image) => {
      const buffer = data[image.imageRole];

      if (buffer && buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
        const byteArray = new Uint8Array(buffer.data);
        const blob = new Blob([byteArray], { type: 'image/jpeg' });
        const url = URL.createObjectURL(blob);
        objectUrls.push(url);

        return {
          ...image,
          src: '', // nothing uploaded yet
          previewUrl: url, // use this for preview
        };
      }

      return image;
    });

    setImages(updatedImages);

    // Cleanup blob URLs
    return () => {
      objectUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [data, isSuccess, setImages]);

  const handleImageChange = (index, file) => {
    const updated = [...images];
    updated[index].src = file;
    setImages(updated);
  };

  const handleImageRemove = (index) => {
    const updated = [...images];
    updated[index].src = '';
    updated[index].previewUrl = '';
    setImages(updated);
  };

  return (
    <figure className='images-container'>
      {images.map((img, index) => (
        <UploadableImage
          key={index}
          index={index}
          image={img.src instanceof File ? img.src : null}
          previewUrl={img.previewUrl}
          onImageChange={(file) => handleImageChange(index, file)}
          onImageRemove={() => handleImageRemove(index)}
        />
      ))}
    </figure>
  );
};

export default ImageSection;
